import { type UseGetMenusArgs } from "./hooks/use-get-menus";

export const menusKeys = {
  all: ["menus"] as const,
  details: () => [...menusKeys.all, "detail"] as const,
  detail: (params: UseGetMenusArgs) => [...menusKeys.details(), params] as const
};
